import React from 'react';
import { PickingBatchInfoTemplate } from 'themes/modules/picking-batch/pages';
import { PickingBatchInfoViewStore } from '../stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore, componentProps) => new PickingBatchInfoViewStore(rootStore, componentProps), 'pickingBatchInfoViewStore')
class PickingBatchInfo extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return <PickingBatchInfoTemplate {...this.props} />;
    }
}

export default PickingBatchInfo;
